import React, { useState } from "react";
import { format } from "date-fns";
import { object, bool } from "prop-types";

import Resizer from "../resizer";
import FollowUs from "../follow-us";

import Authors from "../../../atoms/author";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import SocialMediaShare from "../../../molecules/social-media-share";

import "./author-and-timestamp.m.css";

const AuthorAndTimeStamp = ({ story, isPVExclusive, isSponsoredStory }) => {
  const [showSharingOptions, setShowSharingOptions] = useState(false);
  const publishedDateAndTime = format(new Date(story && story["first-published-at"]), "dd MMMM yyyy, HH:mm");
  const lastUpdatedDateAndTime = format(new Date(story && story["last-published-at"]), "dd MMMM yyyy, HH:mm");

  const sharingHandler = () => {
    setShowSharingOptions(!showSharingOptions);
  };

  if (isPVExclusive) {
    return (
      <div styleName="pvexclusive">
        {!isSponsoredStory && <Authors authors={story.authors} clazzName="author-name-image" />}
        <div styleName="exclusive-timestamp">
          <div styleName="date">Last Updated {lastUpdatedDateAndTime} IST</div>
        </div>
        <div styleName="long-line"></div>
      </div>
    );
  }

  return (
    <div styleName="wrapper">
      {!isSponsoredStory && <Authors authors={story.authors} clazzName="author-name-image" />}
      <div styleName="timestamp-share-wrapper">
        <div styleName="timestamp">
          <div styleName="date">Last Updated {lastUpdatedDateAndTime} IST</div>
        </div>
        <div styleName="author-resize-wrapper-contents">
          <FollowUs />
          <div styleName="share">
            <button onClick={sharingHandler}>
              <SvgIconHandler type="blackshare" height="32px" width="32px" />
            </button>
            <div styleName="share-options">{showSharingOptions && <SocialMediaShare story={story} />}</div>
          </div>
          <Resizer story={story} />
        </div>
      </div>
    </div>
  );
};

AuthorAndTimeStamp.propTypes = {
  story: object,
  isPVExclusive: bool,
  isSponsoredStory: bool
};

AuthorAndTimeStamp.defaultProps = {
  isPVExclusive: false,
  isSponsoredStory: false
};
export default AuthorAndTimeStamp;
